import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'CheckboxCustomFieldFilterController',
            CheckboxCustomFieldFilterController
        );

    function CheckboxCustomFieldFilterController($scope) {
        var vm = this;

        init();

        function init() {
            vm.toggleVisibility = toggleVisibility;

            detectClickEvent();
            onDestroy();
        }

        function onDestroy() {
            $scope.$on('$destroy', function () {
                angular.element(window).off('click', disableVisibility);
            });
        }

        function setField() {
            if (!vm.field.checkboxes) {
                vm.field.checkboxes = [];

                vm.field.field_options.forEach(function (field) {
                    vm.field.checkboxes.push({
                        checked: false,
                        label: field,
                    });
                });
            }
        }

        function toggleVisibility() {
            setField();

            vm.resultsVisibility = !vm.resultsVisibility;
        }

        function disableVisibility(event) {
            var filterElement = document.getElementById(
                'custom-field-checkbox-' + vm.field.id
            );
            var targetElement = event.target;

            do {
                if (targetElement.id === filterElement.id) {
                    return;
                }

                targetElement = targetElement.parentNode;
            } while (targetElement);

            vm.resultsVisibility = false;
            $scope.$apply();
        }

        function detectClickEvent() {
            angular.element(window).on('click', disableVisibility);
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/custom-fields-filters/checkbox/checkbox.controller.ts